import api, { unwrap } from './client';

const base = (tenantId) => `/financials/custom-reports/${tenantId}`;

// Catalogue des sources disponibles (lignes / sections / sous-totaux P&L + Bilan).
export const getCatalog = (tenantId, year) =>
  unwrap(api.get(`${base(tenantId)}/catalog`, { params: { year } }));

// Pages (tableaux de bord)
export const listPages   = (tenantId)            => unwrap(api.get(`${base(tenantId)}/pages`));
export const createPage  = (tenantId, name)      => unwrap(api.post(`${base(tenantId)}/pages`, { name }));
export const updatePage  = (tenantId, id, name)  => unwrap(api.patch(`${base(tenantId)}/pages/${id}`, { name }));
export const deletePage  = (tenantId, id)        => unwrap(api.delete(`${base(tenantId)}/pages/${id}`));
export const reorderPages = (tenantId, ids)      => unwrap(api.post(`${base(tenantId)}/pages/reorder`, { ordered_ids: ids }));
export const getPageView = (tenantId, id, year)  => unwrap(api.get(`${base(tenantId)}/pages/${id}/view`, { params: { year } }));

// Rapports
export const listReports  = (tenantId, pageId)    => unwrap(api.get(base(tenantId), { params: pageId !== undefined ? { page_id: pageId } : {} }));
export const getReport    = (tenantId, id)        => unwrap(api.get(`${base(tenantId)}/${id}`));
export const createReport = (tenantId, payload)   => unwrap(api.post(base(tenantId), payload));
export const updateReport = (tenantId, id, patch) => unwrap(api.patch(`${base(tenantId)}/${id}`, patch));
export const deleteReport = (tenantId, id)        => unwrap(api.delete(`${base(tenantId)}/${id}`));
export const reorderReports = (tenantId, ids)     => unwrap(api.post(`${base(tenantId)}/reports/reorder`, { ordered_ids: ids }));

// Vue calculée d'un rapport seul (réel uniquement)
export const getReportView = (tenantId, id, year) =>
  unwrap(api.get(`${base(tenantId)}/${id}/view`, { params: { year } }));

// Lignes
export const addLine     = (tenantId, id, payload)      => unwrap(api.post(`${base(tenantId)}/${id}/lines`, payload));
export const updateLine  = (tenantId, id, lineId, patch) => unwrap(api.patch(`${base(tenantId)}/${id}/lines/${lineId}`, patch));
export const deleteLine  = (tenantId, id, lineId)        => unwrap(api.delete(`${base(tenantId)}/${id}/lines/${lineId}`));
export const reorderLines = (tenantId, id, orderedIds)   => unwrap(api.post(`${base(tenantId)}/${id}/lines/reorder`, { ordered_ids: orderedIds }));
